import { IParsedWhitelabelWithRelations } from '@/Interfaces/Whitelabels/Whitelabel.interface';
import { useFormContext } from 'react-hook-form';
import OrganizationSelect from '../OrganizationSelect';
import AdditionalControlsInputLabel from './AdditionalControlsInputLabel';

interface IProps {
  organizations: IParsedWhitelabelWithRelations[];
  shouldUnregister?: boolean;
}

const AdditionalOrgAdminControls = ({ organizations, shouldUnregister }: IProps) => {
  const { control } = useFormContext();

  return (
    <>
      <hr className='-mx-[32px] mt-8 mb-4' />
      <div className='mb-3'>
        <AdditionalControlsInputLabel htmlFor='org-select' id='org-select-label'>
          Select Organization
        </AdditionalControlsInputLabel>
        <OrganizationSelect
          control={control}
          options={organizations}
          shouldUnregister={shouldUnregister}
          id='org-select'
          name='organization'
          placeholder='Select Organization'
        />
      </div>
    </>
  );
};

export default AdditionalOrgAdminControls;
